<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="detailList"
		selection
		:excel="isButton_(scrId, 'EX')"
		@changedPage="onChangePage"
		v-bind="detailPagingInfo"
		:pageUnit="detailPagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="detailPagingInfo.totalSize"
	>
		<template v-slot:actionsLeft>
			<!-- 추가 -->
			<sf-button line size="sm" v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addRow">{{
				getButtonMsg_(scrId, 'AD')
			}}</sf-button>
			<!-- 저장 -->
			<sf-button line size="sm" v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveDtlAction">{{
				getMessage_('MWCC000138')
			}}</sf-button>
			<!-- 1.67 -->
			<sf-button line size="sm" v-if="isButton_(scrId, 'CU')" icon="file" :onClick="() => saveDefAction('A')">{{ 1.67 }}</sf-button>
			<!-- 1.33 -->
			<sf-button line size="sm" v-if="isButton_(scrId, 'CU')" icon="file" :onClick="() => saveDefAction('B')">{{ 1.33 }}</sf-button>
			<!-- 삭제 -->
			<sf-button line size="sm" v-if="isButton_(scrId, 'CD')" icon="trash" :onClick="deleteAction">{{
				getMessage_('QWCC001136')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	async created() {
		this.screen = this.screenArray.get(this.scrId);
		await this.getCommCodes_({ key: 'jgmtCrtnList', codeType: 'JGMT_CRTN' }); //판정기준;
		await this.getCommCodes_({ key: 'passDsqfList', codeType: 'INDV_JGMT' }); //합불기준코드;
		await this.getCommCodes_({ key: 'useYnDtlList', codeType: 'USE_YN' }); //사용여부;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.detailList;
		},
		columns() {
			return [
				// { label: 'No.', prop: 'rnum', width: '60px' },
				{ label: 'partNo', prop: 'partNo', width: '1px' },
				{ label: 'ckuPrvsCd', prop: 'ckuPrvsCd', width: '1px' },
				{ label: 'prvsClCd', prop: 'prvsClCd', width: '1px' }, // 항목분류 'QWCC001059'
				{
					//사용여부
					label: this.getMessage_('MWCC000145'),
					prop: 'useYn',
					width: '90px',
					form: {
						type: 'select',
						options: this.getUseYnDtlList_
					}
				},
				{
					// 항목분류명
					label: this.getMessage_('QWCC001060'),
					prop: 'prvsClNm',
					width: '120px'
				},
				{
					// 판정기준
					label: this.getMessage_('QWCC001076'),
					prop: 'jgmtCrtnCd',
					width: '90px',
					form: {
						type: 'select',
						options: this.getJgmtCrtnList_
					}
				},
				{
					// 최소 < Cp
					label: this.getMessage_('QWCC001074') + '<= Cp',
					prop: 'jgmtMinVal',
					width: '110px',
					maxLength: 5,
					form: {
						// type: 'input',
						maxLength: 5,
						type: 'number',
						isDisabled: this.isAdded
					}
				},
				{
					// Cp < 최대
					label: 'CP <' + this.getMessage_('QWCC001075'),
					prop: 'jgmtMaxVal',
					width: '110px',
					form: {
						// type: 'input',
						maxLength: 5,
						type: 'number',
						isDisabled: this.isAdded
					}
				},
				{
					// 판정내용
					label: this.getMessage_('QWCC001073'),
					prop: 'jgmtNm',
					width: '140px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: this.isAdded
					}
				},
				{
					// 합불기준
					label: this.getMessage_('QWCC000062'),
					prop: 'passDsqfCd',
					width: '80px',
					form: {
						type: 'select',
						options: this.getPassDsqfList_
					}
				}

				// { label: this.getMessage_('MWCC000146'), prop: 'regDt', width: '250px' },
				// { label: this.getMessage_('MWCC000005'), prop: 'regId', width: '200px' },
				// { label: this.getMessage_('MWCC000171'), prop: 'chgDt', width: '250px' },
				// { label: this.getMessage_('MWCC000172'), prop: 'chgId', width: '200px' }
			];
		},
		schema() {
			return yup.object().shape({
				jgmtCrtnCd: yup.string().required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001076')])), //{0}은(는) 필수 입력 값 입니다. , 판정기준
				// jgmtMinVal: yup
				// 	.string()
				// 	.trim()
				// 	.default('')
				// 	// .required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001074')])) // 은 필수 입력 항목입니다. , 최소
				// 	.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('QWCC001074'), 1])) // {0}은 최소 {1}자리 이상 입력해야합니다.
				// 	.max(5, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('QWCC001074'), 5])), // {0}은 최대 {1} 자리까지 입력 가능합니다.
				// jgmtMaxVal: yup
				// 	.string()
				// 	.trim()
				// 	.default('')
				// 	// .required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001075')]))
				// 	.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('QWCC001075'), 1])) // {0}은 최소 {1}자리 이상 입력해야합니다.
				// 	.max(5, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('QWCC001075'), 5])), // {0}은 최대 {1} 자리까지 입력 가능합니다.
				jgmtNm: yup
					.string()
					.trim()
					.default('')
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC001073')])) // 은 필수 입력 항목입니다. , 최소
					.max(20, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('QWCC001073'), 20])), // {0}은 최대 {1} 자리까지 입력 가능합니다.
				passDsqfCd: yup
					.string()
					.nullable()
					.default('N')
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('QWCC000062')])) // 은 필수 입력 항목입니다. , 합불기준
				// useYn: yup.string().trim().default('Y')
			});

			// return yup.array().of(
			// 	yup.object().shape({
			// 		jgmtCrtnCd: yup
			// 			.string()
			// 			.nullable()
			// 			.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001076')])),
			// 		//{0}은(는) 필수 입력 값 입니다. , 판정기준
			// 		// jgmtMinVal: yup
			// 		// 	.string()
			// 		// 	//.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001074')])) //{0}은(는) 숫자만 입력 가능합니다.
			// 		// 	// .nullable()
			// 		// 	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001074')])), //{0}은(는) 필수 입력 값 입니다. , 최소 (cp)
			// 		// jgmtMaxVal: yup
			// 		// 	.number()
			// 		// 	.typeError(this.$sf_formatString(this.getMessage_('MWCC000895'), [this.getMessage_('QWCC001075')])) //{0}은(는) 숫자만 입력 가능합니다.
			// 		// 	.nullable()
			// 		// 	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001075')])), //{0}은(는) 필수 입력 값 입니다. , 최대 (cp)
			// 		jgmtNm: yup
			// 			.string()
			// 			.nullable()
			// 			.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001073')])), //{0}은(는) 필수 입력 값 입니다. , 판정내용
			// 		useYn: yup.string().trim().default('Y')
			// 	})
			// );
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		// isAdded: ({ row }) => row.status !== 'I',
		isAdded({ row }) {
			if (row.rowType && row.rowType === 'add') return true;
			else return false;
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.searchCommCd_({ currentPage: currentPageVal, pageUnit: pageUnitVal, commCdType: this.currentCommCdType }).finally(() =>
				this.$sf_toggleLoading(false)
			);
		},
		addRow() {
			if (this.getLeftItemSelectedYn_ != 'Y') {
				this.$sf_showMessage({
					icon: 'error',
					//title: this.getMessage_('QWCC000002'),
					message: this.getMessage_('QWCC000002')
				}); //왼쪽 그리드의 행을 선택해 주시기 바랍니다.
				return;
			}
			// if (!this.currentCommCdType) {
			// 	return;
			// }
			const selectedRows = this.$refs.table.getSelectedRows();
			const toggleRowSelection = this.$refs.table.getTable().toggleRowSelection;
			this.addDetailRow_(this.currentMstValue).then(addedRow => {
				selectedRows.push(addedRow);
				selectedRows.forEach(row => {
					toggleRowSelection(row);
				});
			});
			this.$refs.table.scrollBottom();
		},
		async saveDtlAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selectedRow = this.$refs.table.getSelectedRows();
			if (selectedRow.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 유효성 검사
			try {
				for (let i = 0; i < selectedRow.length; i++) {
					// this.schema.validateSync([{ selectedRow }]);
					this.schema.validateSync(selectedRow[i]);
					this.makeValidateDetail(selectedRow[i]);
				}

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: this.saveDtl }] //저장
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
			// for (let i = 0; i < selectedRow.length; i++) {
			// }
		},
		async saveDtl() {
			this.$sf_toggleLoading(true);
			try {
				const saveRows = this.$refs.table.getSelectedRows();
				const mstParams = this.currentMstValue;
				const { code, messageCd } = await this.saveDetail_({ mstParams, saveRows });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		makeValidateDetail(row) {
			// console.log('row >>> ', row);

			let min = parseFloat(row.jgmtMinVal);
			let max = parseFloat(row.jgmtMaxVal);

			// if (chkYn) {
			if ((min === null || min === '') && (max === null || max === '')) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001209'))); // 최대값 또는 최소값을 하나라도 입력해야합니다.
			}

			// 최대 최소값 체크
			if (min >= 0 || max >= 0) {
				if (min >= max) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001210'))); // 최대값은 최소값보다 높게 입력해야합니다.
				}
			}

			// console.log('min NaN', min === NaN, min === undefined, isNaN(min));
			// console.log('max NaN', max === NaN, max === undefined, isNaN(max));

			// 구간체크
			let lists = this.detailList;
			// console.log('lists >>>', lists, min, max);
			for (let i = 0; i < lists.length; i++) {
				let chkMin = parseFloat(lists[i].jgmtMinVal);
				let chkMax = parseFloat(lists[i].jgmtMaxVal);
				let cnt1 = 0;
				let cnt2 = 0;

				if (chkMin === null || isNaN(min)) {
					chkMin = -99999;
				}

				if (chkMax === null || isNaN(max)) {
					chkMax = 99999;
				}

				for (let j = 0; j < lists.length; j++) {
					if (lists[j].jgmtMinVal <= chkMin && chkMin < lists[j].jgmtMaxVal) {
						cnt1++;
					}
					if (lists[j].jgmtMinVal <= chkMax && chkMax < lists[j].jgmtMaxVal) {
						cnt2++;
					}
				}
				// console.log('cnt >>>', cnt1, cnt2);

				if (cnt1 > 1 || cnt2 > 1) {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001820'))); // Cp값이 중복되는 구간이 존재합니다.
				}
			}

			// }
		},
		deleteAction() {
			//체크박스로 선택된 행이 있는지 확인
			const selectedRow = this.$refs.table.getSelectedRows();
			if (selectedRow.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			// 유효성 검사
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001196'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001136'), clickFn: this.deleteDetail }] //삭제
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async deleteDetail() {
			this.$sf_toggleLoading(true);
			try {
				const delRows = this.$refs.table.getSelectedRows();
				const mstParams = this.currentMstValue;
				const { code, messageCd } = await this.deleteDetail_({ mstParams, delRows });

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		saveDefAction(defaultCd) {
			//console.log(defaultCd);

			let defValue = '1.67';
			if (defaultCd === 'B') {
				defValue = '1.33';
			}

			// 유효성 검사
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.$sf_formatString(this.getMessage_('QWCC001932'), [defValue]), //{0} 으로 판정기준값을 적용하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001933'), clickFn: () => this.saveCpkDef(defValue) }] //적용
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async saveCpkDef(defValue) {
			const mstParams = this.currentMstValue;
			let params = {
				defCpk: defValue
			};

			try {
				const mstParams = this.currentMstValue;
				if (mstParams.partNo === '' || mstParams.ckuPrvsCd === '' || mstParams.prvsClCd === '') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC000002'))); // 왼쪽 그리드의 행을 선택해 주시기 바랍니다.
				}
				const { code, messageCd } = await this.saveCpkDef_({ mstParams, params });

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('Refresh');
				}
				// this.resetTable();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	}
};
</script>

<style>
.flex-row-container {
	display: flex;
	flex-direction: row;
	gap: 16px;
}
.grid-wrapper {
	overflow: hidden;
	display: grid;
	flex: 1;
	grid-template-columns: repeat(4, 1fr);
	grid-template-rows: repeat(1, 1fr);
	grid-gap: 20px;
}
</style>
